import React from 'react';
import { useEffect, useState } from "react";
import { Button, Card, Grid, IconButton, Typography } from "@mui/material";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import colors from '../../../colors';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import { texts } from '../../../general/texts';
import NotificationsIcon from '@material-ui/icons/Notifications';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import CircleNotificationsIcon from '@mui/icons-material/CircleNotifications';

const News = ({ classes, news }) => {

  const [activeStep, setActiveStep] = useState(0);
  const maxSteps = news ? news.length : 0;
  const [dialogOpen, setDialogOpen] = useState(false);
  const isSmallScreen = useMediaQuery('(max-width:600px)');

  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const handleNext = () => {
    {
      activeStep === maxSteps - 1
        ? setActiveStep(0)
        : setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const handleBack = () => {
    {
      activeStep === 0
        ? setActiveStep(maxSteps - 1)
        : setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  }

  useEffect(() => {
    if (news && news.length > 1) {
      const interval = setInterval(() => {
        {
          activeStep === maxSteps - 1
            ? setActiveStep(0)
            : setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
      }, 10000);

      return () => clearInterval(interval);
    }

  }, [activeStep]);

  const newsTitle = news && news[activeStep] ? news[activeStep].title : '';
  const newsContent = news && news[activeStep] ? news[activeStep].content : '';
  const newsUrl = news && news[activeStep] ? news[activeStep].url : '';

  return (
    <>
      <Card className={classes.newsCard}>
        <div style={{ display: 'flex' }}>
          <p style={{ color: colors.orange, marginTop: '10px', marginLeft: '5px', fontSize: 15 }}><CircleNotificationsIcon /></p>
          <IconButton onClick={handleBack} disableRipple={true}  disabled={activeStep === 0 || maxSteps <= 1} style={{ marginTop: '40px', marginLeft: '10px' }}>
            <KeyboardArrowLeft />
          </IconButton>
          <Grid item xs={8} container direction="column">
            <Grid item>
              <Typography style={{ fontSize: '14px', fontFamily: 'GerberaBold', color: colors.darkBlue, marginTop: '15px', marginBottom: '10px' }}>{newsTitle}</Typography>
            </Grid>
            <Grid item>
              <Typography style={{ fontSize: '12px', fontFamily: 'GerberaLight', color: colors.darkBlue }}> {maxSteps > 0 ? `${newsContent.substring(0, 100)}...` : undefined}</Typography>
            </Grid>
          </Grid>
          <IconButton onClick={handleNext} disableRipple={true} disabled={activeStep === maxSteps - 1 || maxSteps <= 1} style={{ marginTop: '40px' }}>
            <KeyboardArrowRight />
          </IconButton>
        </div>
        <Button onClick={handleOpenDialog}>
          <Typography style={{ fontSize: '12px', fontFamily: 'GerberaBold', color: colors.orange }}>
            {texts["prompt-more"]}...
          </Typography>
        </Button>
      </Card>
      {dialogOpen && (
        <Dialog
          open={dialogOpen}
          onClose={handleCloseDialog}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
          PaperProps={{
            style: {
              borderRadius: '20px',
              width: '600px'
            },
          }}>
          <DialogTitle id="scroll-dialog-title" sx={{ textAlign: 'center', background: colors.gradientOrange, color: colors.white, fontSize: '1rem', fontFamily: 'GerberaBold' }}>{newsTitle}</DialogTitle>
          <DialogContent sx={{ fontSize: '1rem', color: colors.darkBlue, textAlign: 'start', fontFamily: "GerberaLight", p: 5, mt: 5, display: 'flex', flex: 'row' }}>
            {newsUrl ? (<img src={newsUrl} style={{ width: '100px', height: '100px', borderRadius: '8px', marginRight: '4%', marginTop: '5%' }} />) : (<NotificationsIcon style={{ fontSize: 50, color: colors.orange, marginRight: '10px', marginTop: isSmallScreen? 40 : '10px' }} />)}
            <Typography>{newsContent}</Typography>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default News;